const fetchRecentlyViewedSpacesReducer = (state, action) => {
  switch (action.status) {
    case 'started':
      return {
        ...state,
        recentlyViewedSpaces: {
          ...state.recentlyViewedSpaces,
          status: 'started',
        },
      };
    case 'success': {
      return {
        ...state,
        recentlyViewedSpaces: {
          spaceList: Array.isArray(action?.payload)
            ? [...(action?.payload ?? [])]
            : [],
          isErrored: false,
          status: 'success',
        },
      };
    }
    case 'error':
      return {
        ...state,
        recentlyViewedSpaces: {
          spaceList: action?.payload ?? [],
          isErrored: true,
          status: 'error',
        },
      };

    default:
      return state;
  }
};

export { fetchRecentlyViewedSpacesReducer };
